import { render, staticRenderFns } from "./PhilosophyLecturers.vue?vue&type=template&id=26f06661&scoped=true"
import script from "./PhilosophyLecturers.vue?vue&type=script&lang=js"
export * from "./PhilosophyLecturers.vue?vue&type=script&lang=js"
import style0 from "./PhilosophyLecturers.vue?vue&type=style&index=0&id=26f06661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f06661",
  null
  
)

export default component.exports